import { applyAuthTokenHeader, rolesManipulator } from 'auth';
import { Api as IdentityCenterApi } from 'identity-center-api';
import {
  attachSessionRecoveryInterceptors,
  createComplianceSessionRecovery,
} from '@/modules/common/api/session-recovery/index.ts';
import { BUSINESS_QUERY_PARAM } from '@/modules/common/constants/search-params.ts';
import { Api } from 'compliance-api';

export const api = new Api({
  baseURL: import.meta.env.VITE_API_URL,
  validateStatus: status => status >= 200 && status < 300,
});

api.instance.interceptors.request.use(
  rolesManipulator.apply_app_role_header.bind(rolesManipulator),
);

export const identityCenterApi = new IdentityCenterApi({
  baseURL: import.meta.env.VITE_IDENTITY_CENTER_API_URL,
  validateStatus: status => status >= 200 && status < 300,
});

identityCenterApi.instance.interceptors.request.use(applyAuthTokenHeader);

api.instance.interceptors.request.use(applyAuthTokenHeader);

const sessionRecovery = createComplianceSessionRecovery();

attachSessionRecoveryInterceptors(api.instance, sessionRecovery);
attachSessionRecoveryInterceptors(identityCenterApi.instance, sessionRecovery);

api.instance.interceptors.request.use(config => {
  const params = new URLSearchParams(location.search);
  const businessId = params.get(BUSINESS_QUERY_PARAM);

  if (businessId) {
    config.headers['x-Business-ID'] = businessId;
  }
  return config;
});
